export default __webpack_public_path__ + "static/media/flag-jersey.050e2c19.svg";